import { createContext, useState, useContext, useEffect } from "react";
import Cookie from "js-cookie";
import axios from "axios";
import { toast } from "sonner";
import { BaseUrlApi, ErrorMessage } from "../lib/api";
import { useAuth } from "./AuthContext";

const APIContext = createContext();

export const useAPI = () => {
  return useContext(APIContext);
};

export const APIProvider = ({ children }) => {
  const { token } = useAuth();

  // -------------Lessons-------------
  const [loadingLessons, setLoadingLessons] = useState(false);
  const [lessons, setLessons] = useState([]);

  const getAllLessons = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/lessons`);
      setLessons(data.data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingLessons(false);
    }
  };

  const lessonsItems = { lessons, loadingLessons, getAllLessons };

  useEffect(() => {
    if (token) {
      setLoadingLessons(true);
      getAllLessons();
    }
  }, [token]);

  // -------------Categories-------------
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [categories, setCategories] = useState([]);

  const getAllCategories = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/categories`);
      setCategories(data.data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingCategories(false);
    }
  };

  const categoriesItems = { categories, loadingCategories, getAllCategories };

  useEffect(() => {
    if (token) {
      setLoadingCategories(true);
      getAllCategories();
    }
  }, [token]);

  // -------------SubCategories-------------
  const [loadingSubCategory, setLoadingSubCategory] = useState(false);
  const [subCategories, setSubCategories] = useState([]);

  const getAllSubCategories = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/sub-categories`);
      setSubCategories(data.data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingSubCategory(false);
    }
  };

  const subCategoriesItems = {
    loadingSubCategory,
    subCategories,
    getAllSubCategories,
  };

  useEffect(() => {
    if (token) {
      setLoadingSubCategory(true);
      getAllSubCategories();
    }
  }, [token]);

  // -------------Courses-------------
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [courses, setCourses] = useState([]);

  const getAllCourses = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/sub-categories/courses`);
      setCourses(data.data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingCourses(false);
    }
  };

  const coursesItems = {
    loadingCourses,
    courses,
    getAllCourses,
  };

  useEffect(() => {
    if (token) {
      setLoadingCourses(true);
      getAllCourses();
    }
  }, [token]);

  // -------------Teacher Courses-------------
  const [loadingTeacherCourses, setLoadingTeacherCourses] = useState(false);
  const [teacherCourses, setTeacherCourses] = useState([]);

  const getAllTeacherCourses = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/teacher/courses`);
      setTeacherCourses(data.data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingTeacherCourses(false);
    }
  };

  const TeacherCoursesItems = {
    loadingTeacherCourses,
    teacherCourses,
    getAllTeacherCourses,
  };

  useEffect(() => {
    if (token) {
      setLoadingTeacherCourses(true);
      getAllTeacherCourses();
    }
  }, [token]);

  // -------------Student Courses-------------
  const [loadingStudentCourses, setLoadingStudentCourses] = useState(false);
  const [studentCourses, setStudentCourses] = useState([]);

  const getAllStudentCourses = async () => {
    try {
      const { data } = await axios.get(`${BaseUrlApi}/student/courses`);
      setStudentCourses(data.data);
    } catch (error) {
      toast("Error", {
        description: ErrorMessage(error),
      });
    } finally {
      setLoadingStudentCourses(false);
    }
  };

  const studentCoursesItems = {
    loadingStudentCourses,
    studentCourses,
    getAllStudentCourses,
  };

  useEffect(() => {
    if (token) {
      setLoadingStudentCourses(true);
      getAllStudentCourses();
    }
  }, [token]);

  return (
    <APIContext.Provider
      value={{
        categoriesItems,
        subCategoriesItems,
        coursesItems,
        TeacherCoursesItems,
        lessonsItems,
        studentCoursesItems,
      }}
    >
      {children}
    </APIContext.Provider>
  );
};
